// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  margin: 0 30px !important;
}

a {
  text-decoration: none !important;
}
a:hover {
  cursor: pointer;
}

.title {
  text-align: center;
  background-color: white;
  padding: 15px 0;
  font-size: 1.63em;
  font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #0B2D71;
  text-transform: lowercase;
  margin-bottom: 0;
}

.subtitle {
  text-align: left;
  font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #3a3a3a;
  text-transform: lowercase;
}

.subtitle_noCase {
  text-align: left;
  font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #3a3a3a;
}

.cvx-button {
  background-color: #0066b2 !important;
  padding: 10px 35px;
  text-transform: lowercase;
  font-size: 14px;
  font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.cvx-button:hover {
  background-color: #0B2D71 !important;
}

.cvx-button-secondary {
  background-color: #00708C !important;
  padding: 10px 35px;
  text-transform: lowercase;
  font-size: 14px;
  font-family: "GothamBold", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.cvx-button-secondary:hover {
  background-color: #003653 !important;
}

.card label {
  font-size: 13px;
}

.separator {
  border-bottom: 1px solid #ededed;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.spinner {
  width: 100%;
  text-align: center;
  height: 250px;
  position: relative;
}
.spinner > div {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.spinner i {
  font-size: 2.5em;
}
.spinner span {
  display: block;
}

.filters {
  background: rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  padding: 15px 0;
}

.var-item label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
  color: #1a1a1a;
}
.var-item span {
  font-weight: 100;
  color: #555;
}

::ng-deep .navbar-default-subsite {
  z-index: initial !important;
}
::ng-deep .navbar-subsite {
  z-index: initial !important;
}
::ng-deep .ui-widget-overlay {
  background-color: rgba(0, 0, 0, 0.7) !important;
  opacity: 1 !important;
  filter: alpha(opacity=100) !important;
}
::ng-deep body .ui-paginator .ui-paginator-pages .ui-paginator-page {
  line-height: initial !important;
}

.visually-hidden {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  word-wrap: normal !important;
}

::ng-deep p-rating a span {
  font-size: 30px !important;
}

textarea {
  height: 75px;
  width: 100%;
  margin-top: 15px;
}

h2 {
  margin-bottom: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
